import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';

const Navbar: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { isAuthenticated, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const links = [
    { label: 'About', href: '#about' }, { label: 'Services', href: '#about' },
    { label: 'Projects', href: '#catalogue' }, { label: 'Team', href: '#team' },
    { label: 'Sublets', href: '#sublet' }, { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-inner">
        <a href="/" className="nav-logo">
          <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-primary-800 rounded-lg flex items-center justify-center">
            <img src="/nidaveLogo.png" alt="Nidave Logo" className="w-10 h-10" />
          </div>
          <div>
            <span className="nav-logo-name">NIDAVE</span>
            <span className="nav-logo-tagline">Industrial Ventures</span>
          </div>
        </a>

        <ul className="nav-links">
          {links.map(l => <li key={l.label}><a href={l.href}>{l.label}</a></li>)}
        </ul>

        <div className="nav-actions">
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            <div className="theme-toggle-thumb">{theme === 'light' ? '☀️' : '🌙'}</div>
          </button>
          {isAuthenticated ? (
            <>
              <Link to="/admin" className="btn-outline" style={{ padding: '8px 18px', fontSize: '0.85rem' }}>Admin</Link>
              <button className="btn-primary" style={{ padding: '8px 18px', fontSize: '0.85rem' }} onClick={logout}>Logout</button>
            </>
          ) : (
            <Link to="/admin/login" className="btn-primary" style={{ padding: '9px 18px', fontSize: '0.85rem' }}>
              <Shield size={14} /> Admin
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
